<script>
import constants from "@/components/constants";

export default {
    name: "LinkTenantSettingTitle",
    emits: ["linkTenantAddRequest"],
    props: {
        settingType: {
            type: Number,
            required: true,
            default: constants.SETTING_INTER_COMPANY_IMPORT,
        },
        currentConnectionsCount: {
            type: Number,
        },
    },
    computed: {
        MAX_C2C_CONNECTIONS() {
            return constants.MAX_C2C_CONNECTIONS;
        },
        settingPageTitle() {
            return this.isImportTenantSetting ? this.$t('message.title_desc_link_tenant1') : this.$t('message.title_desc_link_tenant2')
        },
        settingPageHelp() {
            return this.isImportTenantSetting ? this.$t('message.hint_accessible_tenant') : this.$t('message.hint_allowed_tenant');
        },
        remainingConnectionsCountTitle() {
            return this.$t("message.title_link_remaining_counts", {remainingCount: this.remainingConnectionsCount});
        },
        remainingConnectionsCount() {
            return constants.MAX_C2C_CONNECTIONS - this.currentConnectionsCount;
        },
        isTenantLinkLimitReached() {
            return this.remainingConnectionsCount === 0;
        },
        isImportTenantSetting() {
            return this.settingType === constants.SETTING_INTER_COMPANY_IMPORT;
        },
    },
}
</script>

<template>
    <div class="object-titlebox">
        <div class="title-box-left">
                    <span class="title-box-left__title">
                        {{ settingPageTitle }}
                    </span>
            <el-tooltip effect="dark" placement="top-start">
                <div slot="content" class="tooltip-content">{{ settingPageHelp }}</div>
                <img class="icon-help" :src="require('@/assets/icon_help.svg')" alt="help"/>
            </el-tooltip>
        </div>
        <div class="title-box-right">
            <div class="title-box-right__count">
                        <span class="title-box-right__count-status">
                            {{ $t("message.title_link_counts") }}
                            <span :class="{
                                'title-box-right__current-count': true,
                                'title-box-right__current-count--limit-reached': isTenantLinkLimitReached,
                            }">
                                {{ currentConnectionsCount }}
                            </span>
                            /
                            {{ MAX_C2C_CONNECTIONS }}
                        </span>
                <span class="title-box-right__remaining-count">
                            {{ remainingConnectionsCountTitle }}
                        </span>
            </div>
            <el-tooltip
                :disabled="!isTenantLinkLimitReached"
                effect="dark"
                placement="bottom"
            >
                <div slot="content" v-t="'message.error_exceeds_max_linked_tenants'"></div>
                <button
                    type="button"
                    :class="{
                            'transparent': true,
                            'title-box-right__add_button': true,
                            'title-box-right__add_button--disabled': isTenantLinkLimitReached
                        }"
                    :disabled="isTenantLinkLimitReached"
                    @click="$emit('linkTenantAddRequest')"
                >
                    <img src="@/assets/add_user.svg" alt="add a linked tenant"/>
                    <span class="normal-command-text" v-t="'message.common_action_add'"></span>
                </button>
            </el-tooltip>
        </div>
    </div>
</template>

<style scoped>
.object-titlebox {
    width: auto;
    display: flex;
    align-items: center;
    column-gap: 16px;
    padding: 10px 20px;
    font-size: 12px;

    .title-box-left {
        flex-grow: 1;
        display: flex;
        align-items: center;
        column-gap: 4px;
        flex-wrap: nowrap;

        .title-box-left__title {
            color: #848991;
            white-space: nowrap;
        }
    }

    .title-box-right {
        margin-left: auto;
        flex-grow: 0;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        column-gap: 16px;

        .title-box-right__count {
            color: #848991;

            .title-box-right__count-status, .title-box-right__remaining-count {
                white-space: nowrap;
            }

            .title-box-right__current-count--limit-reached {
                color: #d55169;
            }
        }

        .title-box-right__add_button {
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            padding: 0;
        }

        .title-box-right__add_button--disabled {
            cursor: not-allowed;
            opacity: 0.3;

            .normal-command-text:hover {
                opacity: 1;
            }
        }
    }

    .icon-help {
        height: 14px;
        padding: 0;
    }
}
</style>
